import { makeStyles, tokens } from '@coreai/fluentui-react';

export const useStyles = makeStyles({
  root: {
    position: 'relative',
    flexShrink: 0,
    height: '100%',
    // Width is set via inline style (structural dimension — allowed exception)
    transitionProperty: 'width',
    transitionDuration: tokens.durationNormal,
    transitionTimingFunction: tokens.curveEasyEase,
    // overflow must be visible so the handle (positioned outside) isn't clipped
    overflow: 'visible',
    '@media (prefers-reduced-motion: reduce)': {
      transitionDuration: '1ms',
    },
  },
  rootDragging: {
    transitionProperty: 'none',
  },
  rootCollapsed: {
    overflow: 'hidden',
  },
  content: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
});
